import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder, createFakeDeleteResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createUserStorageApi } from '.';
export var createUserStorageApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createUserStorageApi('', fakeHttp);
    var url = '/storage';
    var testKit = {
        whenGetAll: function () {
            return createFakeGetResponder(fakeHttp, url + '/keys');
        },
        whenGet: function (dto) {
            return createFakeGetResponder(fakeHttp, url + ("/entry?key=" + (dto === '*' ? dto : dto.key)));
        },
        whenSet: function (dto) {
            return createFakePostResponder(fakeHttp, url + "/entry")(dto);
        },
        whenSetMany: function (dto) {
            return createFakePostResponder(fakeHttp, url + '/entries')(dto);
        },
        whenDelete: function (dto) {
            return createFakeDeleteResponder(fakeHttp, url + ("/entry?key=" + (dto === '*' ? dto : dto.key)));
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map